// Blog articles. Each body is a list of blocks: { h2 }, { p }, or { list: [...] }.
// TODO: review articles before publishing; add new posts at the top of the list.

export const posts = [
  {
    slug: 'how-to-choose-stream-after-class-10',
    title: 'How to Choose the Right Stream After Class 10: Science, Commerce or Arts?',
    excerpt: 'A clear, practical guide for students and parents choosing between Science, Commerce and Humanities after Class 10, with careers each stream leads to.',
    date: '2026-10-24',
    readTime: '8 min read',
    author: 'Fedigma Team',
    category: 'Career Guidance',
    relatedService: 'career-counselling',
    body: [
      { p: 'Choosing a stream after Class 10 is one of the first big decisions in a student’s life. It shapes the subjects you study for the next two years and the courses you can apply for after Class 12. The good news: with the right information, it is a decision you can make with confidence.' },
      { h2: 'The three main streams' },
      { p: 'Most schools offer Science, Commerce and Humanities (Arts). Some also offer vocational subjects. Each opens different doors, although many careers today are open to students from more than one stream.' },
      { h2: 'Science' },
      { p: 'Science is usually split into PCM (Physics, Chemistry, Mathematics), PCB (Physics, Chemistry, Biology) or PCMB (all four).' },
      { list: [
        'PCM leads to engineering, architecture, computer science, data science, defence (NDA) and pure sciences',
        'PCB leads to medicine, dentistry, nursing, pharmacy, biotechnology and allied health sciences',
        'PCMB keeps both engineering and medical options open, but is demanding'
      ] },
      { p: 'Choose Science if you genuinely enjoy these subjects and are ready for a heavy workload and competitive entrance exams.' },
      { h2: 'Commerce' },
      { p: 'Commerce covers Accountancy, Business Studies and Economics, usually with optional Mathematics. Taking Maths with Commerce keeps more options open, such as economics honours, actuarial science and data analytics.' },
      { list: [
        'Chartered Accountancy, Company Secretary and Cost Accountancy',
        'B.Com, BBA and management',
        'Banking, finance, economics and business analytics'
      ] },
      { h2: 'Humanities (Arts)' },
      { p: 'Humanities includes subjects like History, Political Science, Geography, Psychology, Sociology, Economics and languages. It is ideal for students who enjoy reading, writing, debating and understanding people and society.' },
      { list: [
        'Law, journalism and mass communication',
        'Psychology, social work and teaching',
        'Design, fine arts and media',
        'Civil services preparation, where humanities subjects are especially useful'
      ] },
      { h2: 'Other routes after Class 10' },
      { p: 'Polytechnic diplomas and ITI courses offer practical, job-oriented training in fields like engineering trades, electronics and computers. They can lead directly to jobs or, in many cases, to lateral entry into degree programmes.' },
      { h2: 'How to decide' },
      { list: [
        'Interest: which subjects do you enjoy and look forward to?',
        'Aptitude: where do your strengths and marks consistently lie?',
        'Career ideas: research what different careers involve day to day',
        'Workload: be honest about how much pressure you can handle',
        'Avoid choosing only because friends are, or for social expectations'
      ] },
      { h2: 'Common myths' },
      { list: [
        'Myth: Science is for "smart" students. Every stream needs hard work and offers excellent careers.',
        'Myth: Arts has no scope. Law, design, psychology, media and civil services all welcome humanities students.',
        'Myth: You cannot change direction later. Many careers are open across streams, and entrance exams like CUET allow flexibility.'
      ] },
      { h2: 'Talk it through' },
      { p: 'If you are still unsure, a career counselling session with your parents can help you understand your strengths, explore options and choose a stream with confidence rather than pressure.' }
    ]
  },
  {
    slug: 'how-to-score-90-percent-in-board-exams',
    title: 'How to Score 90%+ in Board Exams: A Practical Study Plan',
    excerpt: 'A step-by-step plan for Class 10 and 12 board exam preparation, covering syllabus planning, revision, sample papers, answer writing and exam-day tips.',
    date: '2026-10-24',
    readTime: '8 min read',
    author: 'Fedigma Team',
    category: 'Study Tips',
    relatedService: 'career-counselling',
    body: [
      { p: 'Scoring 90% or more in board exams is not about studying 15 hours a day. It is about studying the right things consistently, revising smartly and writing answers the way examiners expect. Here is a practical plan you can follow.' },
      { h2: '1. Know your syllabus and exam pattern' },
      { p: 'Download the latest syllabus and sample papers from your board’s official website. Note deleted topics, the marks for each unit and the types of questions asked. This tells you exactly where to focus.' },
      { h2: '2. Make the textbook your foundation' },
      { p: 'For CBSE and many state boards, most questions come from the prescribed textbooks. Read every chapter thoroughly, including examples, in-text questions and exercises, before moving to reference books.' },
      { h2: '3. Plan backwards from the exam date' },
      { list: [
        'Finish the full syllabus at least 6–8 weeks before exams',
        'Keep the last weeks for revision and practice papers',
        'Set weekly targets for each subject',
        'Review your progress every Sunday and adjust'
      ] },
      { h2: '4. Make your own short notes' },
      { p: 'Summarise each chapter in a page or two: formulas, definitions, key dates, diagrams and important points. These notes become your fastest revision tool.' },
      { h2: '5. Practise previous year and sample papers' },
      { p: 'Solve at least the last five years’ papers and all official sample papers under timed conditions. This builds speed, reduces anxiety and shows you recurring question patterns.' },
      { h2: '6. Learn to write answers that score' },
      { list: [
        'Read the question carefully and answer exactly what is asked',
        'Use headings, points and underlining for key terms',
        'Draw neat, labelled diagrams wherever relevant',
        'Show all steps in Maths and numerical questions',
        'Match answer length to the marks allotted'
      ] },
      { h2: '7. Revise with spaced repetition' },
      { p: 'Revise each chapter several times with increasing gaps: after a day, a week and a month. Spaced revision helps you remember far more than last-minute cramming.' },
      { h2: '8. Don’t ignore weak subjects' },
      { p: 'Your overall percentage depends on every subject. Spend extra time on weaker areas early, and ask teachers for help with concepts you find difficult.' },
      { h2: '9. Look after your health' },
      { p: 'Sleep 7–8 hours, eat regular meals, take short breaks and get some exercise. A tired brain remembers less and makes careless mistakes.' },
      { h2: '10. Exam-day strategy' },
      { list: [
        'Use the reading time to plan which questions to attempt first',
        'Start with questions you know well to build confidence',
        'Keep an eye on time for each section',
        'Leave 10–15 minutes to review your answers'
      ] },
      { h2: 'Consistency beats intensity' },
      { p: 'A focused 5–6 hours of daily study, maintained over months, works far better than panic studying in the final weeks. Start early, stay consistent and trust your preparation.' }
    ]
  },
  {
    slug: 'how-to-make-a-study-timetable',
    title: 'How to Make a Study Timetable That Actually Works',
    excerpt: 'Step-by-step guidance for students on building a realistic study timetable, with sample schedules for school days, holidays and exam preparation.',
    date: '2026-10-24',
    readTime: '6 min read',
    author: 'Fedigma Team',
    category: 'Study Tips',
    relatedService: 'career-counselling',
    body: [
      { p: 'Most study timetables fail because they are unrealistic: too many hours, no breaks and no room for real life. A good timetable fits your day, balances subjects and is easy to stick to.' },
      { h2: 'Step 1: Track your current day' },
      { p: 'For two or three days, note how you actually spend your time: school, coaching, travel, meals, phone and sleep. This shows how many hours are realistically free for study.' },
      { h2: 'Step 2: List subjects and priorities' },
      { p: 'Write down every subject and rate each as strong, average or weak. Weak subjects and those with exams coming up soon need more time.' },
      { h2: 'Step 3: Use focused study blocks' },
      { p: 'Study in blocks of 45–60 minutes followed by a 5–10 minute break. Some students prefer the Pomodoro method: 25 minutes of focus and a 5-minute break, with a longer break after four rounds.' },
      { h2: 'Step 4: Match tasks to your energy' },
      { list: [
        'Hard subjects and new concepts when you are most alert',
        'Practice questions and revision when energy is medium',
        'Light reading or flashcards when you are tired'
      ] },
      { h2: 'Step 5: Mix subjects' },
      { p: 'Switching between two or three subjects in a day keeps you fresh and improves long-term memory compared to studying one subject all day.' },
      { h2: 'Sample timetable for a school day' },
      { list: [
        '5:00–6:30 pm: Difficult subject (new topic)',
        '6:30–6:45 pm: Break',
        '6:45–7:45 pm: Practice questions',
        '7:45–8:30 pm: Dinner and family time',
        '8:30–9:30 pm: Revision of the day’s classes',
        '9:30–10:00 pm: Light reading, then sleep by 10:30'
      ] },
      { h2: 'Sample timetable for holidays' },
      { list: [
        'Morning: two focused blocks on difficult subjects',
        'Afternoon: practice papers and problem solving',
        'Evening: revision and short notes',
        'Keep time for exercise, hobbies and rest'
      ] },
      { h2: 'Tips to stick to it' },
      { list: [
        'Keep your phone in another room during study blocks',
        'Plan one free evening a week',
        'Review every Sunday and adjust what didn’t work',
        'Tick off completed tasks for a sense of progress',
        'Protect your sleep: it is part of studying'
      ] },
      { p: 'The best timetable is one you can follow for weeks, not one that looks perfect on paper. Start realistic and build up gradually.' }
    ]
  },
  {
    slug: 'scholarships-for-students-in-india',
    title: 'Scholarships for Students in India: How to Find and Apply',
    excerpt: 'Types of scholarships available to Indian students, where to find them, documents you need and tips to apply successfully, including the National Scholarship Portal.',
    date: '2026-10-24',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'Career Guidance',
    relatedService: 'career-counselling',
    body: [
      { p: 'Every year, many deserving students miss out on scholarships simply because they did not know about them or missed the deadline. Scholarships can cover tuition fees, books, hostel costs and more. Here is how to find and apply for them.' },
      { h2: 'Types of scholarships' },
      { list: [
        'Merit-based: awarded for strong academic results or entrance exam ranks',
        'Need-based: for students from lower-income families',
        'Category-based: for SC, ST, OBC, minority and other eligible groups',
        'Scholarships for girls, to encourage higher education',
        'Talent and sports scholarships',
        'Course-specific: for engineering, medicine, research and more',
        'Institute scholarships offered by colleges and coaching institutes'
      ] },
      { h2: 'Where to find scholarships' },
      { list: [
        'National Scholarship Portal (scholarships.gov.in), which lists many central and state government schemes',
        'Your state government’s scholarship portal',
        'Your school, college or university scholarship office',
        'Private foundations and company CSR programmes',
        'Coaching institutes, many of which run scholarship tests'
      ] },
      { h2: 'Documents you usually need' },
      { list: [
        'Mark sheets and certificates of previous classes',
        'Income certificate of the family',
        'Caste or category certificate, if applicable',
        'Aadhaar card',
        'Bank account details, often linked to Aadhaar',
        'Admission proof or fee receipt from your institution',
        'Passport-size photograph'
      ] },
      { h2: 'Tips for a successful application' },
      { list: [
        'Start early: keep certificates ready before portals open',
        'Note every deadline and apply well before the last date',
        'Fill details exactly as they appear on official documents',
        'Keep copies of submitted forms and acknowledgement numbers',
        'Check application status regularly and respond to queries',
        'Renew existing scholarships on time each year'
      ] },
      { h2: 'Beware of scholarship scams' },
      { p: 'Genuine government scholarships do not ask you to pay a fee to apply or to "release" your scholarship. Apply only through official portals and your institution, and never share OTPs or passwords.' },
      { h2: 'Need guidance?' },
      { p: 'Scholarship eligibility and deadlines vary widely. Always check the official notification for each scheme. If you are planning courses and colleges, a counsellor can help you include scholarships in your plan.' }
    ]
  },
  {
    slug: 'government-jobs-after-12th',
    title: 'Government Jobs After 12th: Popular Exams and How to Prepare',
    excerpt: 'An overview of popular government job options after Class 12, including SSC, defence, railways and police, plus preparation tips.',
    date: '2026-10-24',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'Career Guidance',
    relatedService: 'career-counselling',
    body: [
      { p: 'Government jobs offer stability, benefits and respect, which is why lakhs of students prepare for them every year. Several government recruitment exams are open to candidates who have passed Class 12. Here is an overview of popular options.' },
      { p: 'Note: eligibility, age limits and exam patterns change. Always read the latest official notification before applying.' },
      { h2: 'Staff Selection Commission (SSC)' },
      { p: 'SSC CHSL recruits for posts such as Lower Division Clerk and Data Entry Operator in central government departments, and is open to Class 12 pass candidates. Other SSC exams, such as GD Constable, are open at Class 10 level.' },
      { h2: 'Defence' },
      { list: [
        'NDA: for officer training in the Army, Navy and Air Force, after Class 12 (Physics and Maths are generally required for the Air Force and Navy wings)',
        'Agniveer recruitment under the Agnipath scheme for the Army, Navy and Air Force, with educational requirements depending on the role',
        'Technical and other entries announced by each service'
      ] },
      { h2: 'Railways' },
      { p: 'The Railway Recruitment Boards conduct exams such as RRB NTPC, which includes undergraduate-level posts open to Class 12 pass candidates, along with other recruitments for different qualification levels.' },
      { h2: 'Police and state government jobs' },
      { p: 'Many state police departments recruit constables with Class 12 as the qualification, along with physical tests. State staff selection boards also conduct exams for clerical and other posts.' },
      { h2: 'Other options' },
      { list: [
        'India Post recruitment for certain posts',
        'State-level clerical and assistant posts',
        'Various central and state government recruitments announced through official notifications'
      ] },
      { h2: 'How to prepare' },
      { list: [
        'Understand the exam pattern: most include reasoning, quantitative aptitude, English and general awareness',
        'Build basics first using school-level Maths and English',
        'Read current affairs daily',
        'Practise previous year papers and mock tests regularly',
        'For defence and police jobs, start physical fitness training early',
        'Track official websites for notifications and deadlines'
      ] },
      { h2: 'Keep higher education going' },
      { p: 'Many students prepare for government exams while continuing graduation through regular or distance learning. A degree opens more senior opportunities later, including bank PO and civil services exams.' }
    ]
  },
  {
    slug: 'best-courses-after-12th-commerce',
    title: 'Best Courses After 12th Commerce: Options, Duration and Careers',
    excerpt: 'Popular courses for Commerce students after Class 12, including B.Com, BBA, CA, CS, CMA, economics and new-age options, with the careers they lead to.',
    date: '2026-10-24',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'Career Guidance',
    relatedService: 'career-counselling',
    body: [
      { p: 'Commerce opens doors to finance, business, management, law and many new-age careers. Here are the most popular courses after Class 12 Commerce and what each leads to.' },
      { h2: 'B.Com and B.Com (Honours)' },
      { p: 'A three-year degree covering accounting, finance, taxation, economics and business law. It is a solid foundation for careers in accounting, banking and finance, and pairs well with professional courses like CA or CS.' },
      { h2: 'Chartered Accountancy (CA)' },
      { p: 'Conducted by the Institute of Chartered Accountants of India (ICAI). Students can begin with the CA Foundation exam after Class 12. CA is demanding but highly respected, leading to careers in audit, taxation, advisory and finance.' },
      { h2: 'Company Secretary (CS)' },
      { p: 'Offered by the Institute of Company Secretaries of India (ICSI). CS professionals handle corporate governance, compliance and company law matters.' },
      { h2: 'Cost and Management Accountancy (CMA)' },
      { p: 'Offered by the Institute of Cost Accountants of India, CMA focuses on cost management, financial planning and strategy.' },
      { h2: 'BBA and BMS' },
      { p: 'Bachelor of Business Administration and Bachelor of Management Studies programmes build skills in marketing, finance, HR and operations, and are a common path to an MBA.' },
      { h2: 'Economics' },
      { p: 'BA or B.Sc in Economics suits students who enjoy analysis and policy. Taking Mathematics in Class 12 is often required or recommended for top economics programmes.' },
      { h2: 'Integrated law (BBA LLB / B.Com LLB)' },
      { p: 'Five-year integrated law programmes combine business and law. Admission to many top law schools is through entrance exams such as CLAT.' },
      { h2: 'New-age options' },
      { list: [
        'Banking and insurance',
        'Financial markets and investment',
        'Business analytics and data science (Maths helps)',
        'Digital marketing',
        'Actuarial science (strong Maths required)',
        'Hotel management and event management'
      ] },
      { h2: 'How to choose' },
      { list: [
        'Pick professional courses like CA, CS or CMA if you enjoy accounts and are ready for rigorous exams',
        'Choose BBA or BMS if you are drawn to management and business',
        'Consider economics or analytics if you enjoy numbers and problem solving',
        'Combine a degree with a professional course for stronger opportunities'
      ] },
      { p: 'Entry requirements and exam patterns change, so always check each institution’s official website. If you are unsure, career counselling can help match your interests and strengths to the right course.' }
    ]
  },
  {
    slug: 'fee-collection-software-for-schools',
    title: 'Fee Collection Software for Schools: Features, Benefits and How to Choose',
    excerpt: 'How fee management software helps schools and coaching institutes collect fees faster, reduce errors and give parents convenient online payment.',
    date: '2026-10-24',
    readTime: '6 min read',
    author: 'Fedigma Team',
    category: 'ERP & Management',
    relatedService: 'school-management',
    body: [
      { p: 'Fee collection is one of the most time-consuming tasks in a school or coaching institute office. Chasing pending fees, writing receipts and reconciling accounts takes hours every week. Fee collection software automates most of this work.' },
      { h2: 'Problems with manual fee collection' },
      { list: [
        'Long queues at the fee counter on due dates',
        'Errors in receipts and records',
        'Hard to track who has paid and who hasn’t',
        'Time-consuming follow-up calls for pending fees',
        'Difficult reconciliation between cash, cheques and online payments'
      ] },
      { h2: 'Key features to look for' },
      { list: [
        'Flexible fee structures by class, batch or course',
        'Instalments, late fees, concessions and sibling discounts',
        'Online payment through UPI, cards and net banking',
        'Automatic digital receipts',
        'Due-date reminders by SMS, WhatsApp or app notification',
        'Real-time reports on collections and pending dues',
        'Integration with student records and the parent app'
      ] },
      { h2: 'Benefits for schools' },
      { list: [
        'Faster collections and fewer defaulters',
        'Less work for office and accounts staff',
        'Accurate records and easy audits',
        'Instant visibility of collections across branches'
      ] },
      { h2: 'Benefits for parents' },
      { list: [
        'Pay from anywhere, anytime',
        'Instant receipts and payment history',
        'Timely reminders instead of last-minute surprises'
      ] },
      { h2: 'Choose an ERP, not just a payment tool' },
      { p: 'Standalone payment links solve only part of the problem. Fee management works best inside a school ERP, where fees connect to admissions, attendance and parent communication. EdTrack Smart, for example, includes fee invoicing, online collection and defaulter reminders alongside student records.' },
      { h2: 'Questions to ask before choosing' },
      { list: [
        'Can it handle our exact fee structure and concessions?',
        'Which payment methods and gateways does it support?',
        'Can parents see fee status in an app?',
        'How are reports exported for accounts?',
        'What does setup, data migration and training include?'
      ] }
    ]
  },
  {
    slug: 'instagram-marketing-for-coaching-institutes',
    title: 'Instagram Marketing for Coaching Institutes: A Complete Guide',
    excerpt: 'How coaching institutes can use Instagram reels, results posts, faculty content and stories to build trust and get more student enquiries.',
    date: '2026-10-24',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'Marketing & Social Media',
    relatedService: 'online-presence',
    body: [
      { p: 'Students spend hours on Instagram every day, and many discover and compare coaching institutes there. A strong Instagram presence builds trust long before a student walks into your centre.' },
      { h2: 'Set up your profile properly' },
      { list: [
        'Use your institute logo as the profile picture',
        'Write a clear bio: courses, exams, location and results',
        'Add a link to your website or enquiry page',
        'Switch to a business or creator account for insights and contact buttons',
        'Create story highlights for Courses, Results, Faculty, Reviews and Admissions'
      ] },
      { h2: 'Content that works for coaching institutes' },
      { list: [
        'Short concept explainers and tricks in reels',
        'Daily quiz questions and answers',
        'Topper interviews and result celebrations',
        'Faculty introductions and teaching snippets',
        'Exam notifications, dates and preparation tips',
        'Daily current affairs for competitive exams',
        'Student testimonials',
        'Behind the scenes: classrooms, doubt sessions and events'
      ] },
      { h2: 'Make reels a priority' },
      { p: 'Reels reach people who don’t follow you yet. Keep them under 60 seconds, hook viewers in the first two seconds, add subtitles and end with a clear message such as "Follow for daily tips" or "Book a free demo".' },
      { h2: 'Post consistently' },
      { p: 'Aim for four to five posts a week, including at least two or three reels, and stories every day. Consistency matters more than perfection.' },
      { h2: 'Engage, don’t just post' },
      { p: 'Reply to comments and messages quickly, run polls and question stickers in stories, and go live for doubt sessions or exam strategy talks.' },
      { h2: 'Use hashtags and location' },
      { p: 'Combine exam hashtags, topic hashtags and local hashtags with your city or area. Tag your location on posts so nearby students can find you.' },
      { h2: 'Turn followers into admissions' },
      { list: [
        'Pin posts about new batches and results',
        'Share demo class and scholarship test details',
        'Route DMs to a counsellor who replies quickly',
        'Track how many enquiries come from Instagram'
      ] },
      { h2: 'Boost your best posts' },
      { p: 'Before a new batch, promote your best-performing reels to students in your target area. Small, targeted budgets often work well when the content is already proven.' }
    ]
  },
  {
    slug: 'school-website-checklist',
    title: 'What Every School Website Must Have: A 15-Point Checklist',
    excerpt: 'The pages, features and details parents look for on a school website, and the common mistakes that cost schools admission enquiries.',
    date: '2026-10-24',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'Websites & Apps',
    relatedService: 'web-development',
    body: [
      { p: 'A school website is often the first place parents form an opinion about your school. In a few minutes they decide whether to call, visit or move on to the next school. Use this checklist to make sure your website answers their questions and makes enquiring easy.' },
      { h2: 'Essential pages' },
      { list: [
        '1. A clear homepage that says who you are, which classes you offer and where you are',
        '2. Admissions: process, eligibility, important dates and an enquiry form',
        '3. Fee structure, or a simple way to request it',
        '4. Academics: curriculum, board affiliation and teaching approach',
        '5. Facilities: classrooms, labs, library, sports, transport and safety',
        '6. Faculty and leadership, with a message from the principal',
        '7. Notices and circulars, kept up to date',
        '8. Results and achievements: board results, competitions and sports',
        '9. A photo and video gallery of real school life',
        '10. Contact details with phone, WhatsApp, email and a Google map'
      ] },
      { h2: 'Features that make a difference' },
      { list: [
        '11. Works perfectly on mobile phones, where most parents browse',
        '12. Loads in a few seconds, even on slower connections',
        '13. A visible "Admissions Open" banner and enquiry button during admission season',
        '14. A WhatsApp chat button so parents can ask quick questions',
        '15. An easy way for your staff to update notices, results and photos themselves'
      ] },
      { h2: 'Common mistakes to avoid' },
      { p: 'Outdated notices from years ago, broken links, stock photos instead of your real campus, missing fee information and no clear way to enquire are the most common problems we see. Each one makes a school look less active and less trustworthy.' },
      { h2: 'Don’t forget Google' },
      { p: 'Your website works best alongside a complete Google Business Profile with reviews. Make sure your school’s name, address and phone number match exactly on both.' },
      { h2: 'Next steps' },
      { p: 'Go through this checklist with your website open on your phone. If several items are missing or hard to find, it may be time for a redesign that turns more visitors into admission enquiries.' }
    ]
  },
  {
    slug: 'does-your-school-need-a-mobile-app',
    title: 'Does Your School Need a Mobile App? Benefits, Features and Costs',
    excerpt: 'When a school or coaching institute app is worth it, which features parents and students actually use, and how to plan one sensibly.',
    date: '2026-10-24',
    readTime: '6 min read',
    author: 'Fedigma Team',
    category: 'Websites & Apps',
    relatedService: 'mobile-app',
    body: [
      { p: 'Parents and students live on their phones. A well-built app can replace scattered WhatsApp groups, paper circulars and phone calls with one place for everything. But not every institute needs a fully custom app on day one.' },
      { h2: 'What a school or institute app can do' },
      { list: [
        'Attendance alerts sent to parents automatically',
        'Homework, circulars and announcements in one place',
        'Fee status, reminders and online payment',
        'Exam schedules, results and report cards',
        'Video lectures, notes and mock tests for coaching students',
        'Transport tracking and pickup updates'
      ] },
      { h2: 'Signs you are ready for an app' },
      { list: [
        'Parents regularly call the office for routine information',
        'Important messages get lost in large WhatsApp groups',
        'You sell courses or test series to students online',
        'You run several branches and need consistent communication'
      ] },
      { h2: 'Start with an ERP-connected app' },
      { p: 'For many schools, the fastest route is an app connected to a school ERP, so attendance, fees and results update automatically. EdTrack Smart, for example, includes a parent and staff portal. A fully custom app makes more sense when you need your own branding, unique features or paid content.' },
      { h2: 'Android, iOS or both?' },
      { p: 'Most parents and students in India use Android phones, so many institutes launch on Android first. Cross-platform frameworks like Flutter let you launch on both for little extra cost.' },
      { h2: 'What affects the cost' },
      { list: [
        'Number of screens and features',
        'Whether it connects to an existing ERP or website',
        'Payments, video content and live classes',
        'Custom design versus a standard layout',
        'Ongoing hosting, updates and support'
      ] },
      { h2: 'The bottom line' },
      { p: 'An app is worth it when it saves your staff time and makes life easier for parents and students. Start with the features people will use every day, launch, gather feedback and improve from there.' }
    ]
  },
  {
    slug: 'how-to-run-a-self-study-library',
    title: 'How to Run a Self-Study Library: Seats, Memberships and Fees',
    excerpt: 'A practical guide for self-study library and reading room owners on managing seats, memberships, fees and attracting more students.',
    date: '2026-10-24',
    readTime: '6 min read',
    author: 'Fedigma Team',
    category: 'ERP & Management',
    relatedService: 'school-management',
    body: [
      { p: 'Self-study libraries and reading rooms have become popular with students preparing for competitive exams. Running one well means keeping seats full, fees collected on time and members happy, without spending your whole day on registers.' },
      { h2: 'Plan your seating and shifts' },
      { p: 'Most study centres offer fixed seats, flexible seats and shift-based plans such as morning, evening or full day. Clearly define each plan, its timings and price, and track which seat belongs to which member.' },
      { h2: 'Keep memberships organised' },
      { list: [
        'Member details, ID proof and emergency contact',
        'Plan type, seat number and validity dates',
        'Payment history and pending dues',
        'Locker allocation if you offer lockers'
      ] },
      { h2: 'Make fee collection easy' },
      { p: 'Accept UPI and online payments, send renewal reminders a few days before a plan expires, and share digital receipts. Automatic reminders alone can noticeably reduce late payments.' },
      { h2: 'Use software instead of registers' },
      { p: 'Library management software lets you see seat availability at a glance, renew memberships in seconds and send reminders automatically. EdTrack Smart includes memberships, seat bookings, book issue and return, and due-date reminders in one system.' },
      { h2: 'Create a comfortable study environment' },
      { list: [
        'Good lighting and comfortable chairs',
        'Reliable Wi-Fi and charging points',
        'Clean washrooms and drinking water',
        'Strict silence rules and clear timings',
        'CCTV and secure entry for safety'
      ] },
      { h2: 'Get found by students nearby' },
      { p: 'Students usually search "library near me" or "study centre near me" on Google Maps. A complete Google Business Profile with real photos, timings, prices and reviews is the most effective way to fill seats. Ask satisfied members to leave reviews.' },
      { h2: 'Grow through referrals' },
      { p: 'Students preparing for the same exams know each other. A small referral discount can bring a steady stream of new members.' }
    ]
  },
  {
    slug: 'social-media-post-ideas-for-schools',
    title: '30 Social Media Post Ideas for Schools and Coaching Institutes',
    excerpt: 'Never run out of ideas again. Thirty post ideas that build trust with parents and students on Instagram, Facebook and YouTube.',
    date: '2026-10-24',
    readTime: '6 min read',
    author: 'Fedigma Team',
    category: 'Marketing & Social Media',
    relatedService: 'online-presence',
    body: [
      { p: 'Posting regularly keeps your institute visible and shows parents and students what makes you special. The hardest part is deciding what to post. Here are thirty ideas you can use all year.' },
      { h2: 'Classroom and campus life' },
      { list: [
        '1. A day in the life of a student',
        '2. Science lab experiments in action',
        '3. Art and craft activities',
        '4. Library or reading corner moments',
        '5. Morning assembly highlights',
        '6. Sports practice and matches'
      ] },
      { h2: 'Achievements and results' },
      { list: [
        '7. Board and exam results',
        '8. Toppers and rank holders',
        '9. Competition and olympiad winners',
        '10. Alumni success stories',
        '11. Teacher awards and certifications'
      ] },
      { h2: 'Meet the people' },
      { list: [
        '12. Teacher introductions',
        '13. Principal’s message',
        '14. Behind the scenes with support staff',
        '15. Student and parent testimonials'
      ] },
      { h2: 'Helpful and educational' },
      { list: [
        '16. Study tips before exams',
        '17. Quick concept explainers in short videos',
        '18. Exam notifications and important dates',
        '19. Daily current affairs for competitive exams',
        '20. Parenting tips for young children',
        '21. Career guidance snippets'
      ] },
      { h2: 'Events and celebrations' },
      { list: [
        '22. Festival celebrations',
        '23. Annual day and sports day',
        '24. Independence Day and Republic Day',
        '25. Teachers’ Day and Children’s Day',
        '26. Field trips and educational tours'
      ] },
      { h2: 'Admissions' },
      { list: [
        '27. "Admissions Open" announcements',
        '28. Campus tour videos',
        '29. Frequently asked admission questions',
        '30. Open day or demo class invitations'
      ] },
      { h2: 'Tips for better results' },
      { p: 'Post three to four times a week, use real photos and short videos rather than stock images, follow your institute’s photo consent policy for children, and plan a monthly content calendar so posting never becomes a last-minute task.' }
    ]
  },
  {
    slug: 'google-ads-for-coaching-institutes',
    title: 'Google Ads for Coaching Institutes: A Beginner’s Guide',
    excerpt: 'How coaching institutes can use Google Ads to get genuine student enquiries, without wasting budget on the wrong clicks.',
    date: '2026-10-24',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'Marketing & Social Media',
    relatedService: 'digital-marketing',
    body: [
      { p: 'When a student searches "NEET coaching near me" or "bank exam coaching in Delhi", they are actively looking. Google Ads lets your institute appear at the top of those searches. Done well, it is one of the fastest ways to fill a new batch.' },
      { h2: 'Start with clear goals' },
      { p: 'Decide which course or batch you are promoting, the area you want to target, how many enquiries you need and your monthly budget. Separate campaigns for each course make results easier to track.' },
      { h2: 'Choose the right keywords' },
      { list: [
        'Course and exam names, such as "JEE coaching" or "SSC CGL coaching"',
        'Location phrases, such as "near me" or your area name',
        'Intent words, such as "admission", "fees", "classes" or "batch"'
      ] },
      { p: 'Add negative keywords like "free PDF", "jobs" or "salary" to avoid paying for clicks from people who are not looking for coaching.' },
      { h2: 'Target your location' },
      { p: 'Show ads only to people within a reasonable distance of your centre, or in the cities your online batches serve. This keeps your budget focused on students who can actually join.' },
      { h2: 'Write ads that stand out' },
      { p: 'Mention what makes you different: results, experienced faculty, batch start dates, small batch sizes, scholarship tests or a free demo class. Include a clear call to action such as "Book a free demo".' },
      { h2: 'Send clicks to a focused landing page' },
      { p: 'Do not send ad traffic to your homepage. Use a page for that specific course with batch details, fees, faculty, results and a short enquiry form or WhatsApp button.' },
      { h2: 'Follow up fast' },
      { p: 'Students compare several institutes at once. Call or WhatsApp every enquiry within minutes, not days. Fast follow-up often matters more than the ad itself.' },
      { h2: 'Measure and improve every week' },
      { p: 'Track cost per enquiry and, more importantly, cost per admission. Pause keywords that bring clicks but no enquiries, and increase budget on those that bring real students.' },
      { h2: 'Common mistakes' },
      { list: [
        'Targeting too wide an area',
        'Sending clicks to the homepage',
        'No conversion tracking',
        'Slow follow-up on enquiries',
        'Starting ads only after the batch has begun'
      ] }
    ]
  },
  {
    slug: 'smart-classroom-setup-guide',
    title: 'Smart Classroom Setup Guide: Interactive Panels vs Projectors',
    excerpt: 'Everything schools should consider before setting up smart classrooms, from choosing interactive panels or projectors to audio, training and support.',
    date: '2026-10-24',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'Smart Classrooms',
    relatedService: 'digital-classroom',
    body: [
      { p: 'Smart classrooms help teachers explain concepts visually, use digital content and keep students engaged. But the right setup depends on your rooms, teachers and budget. Here is what to think about before you buy.' },
      { h2: 'Interactive flat panels' },
      { p: 'Interactive flat panels are large touch screens that work like giant tablets. Teachers can write, draw, open videos and use teaching software directly on the screen.' },
      { list: [
        'Bright, sharp display that works well in daylight',
        'Touch and writing built in',
        'Low maintenance, with no bulbs to replace',
        'Higher upfront cost than projectors'
      ] },
      { h2: 'Projectors' },
      { p: 'Projectors display content on a screen or wall. Paired with an interactive board, they can also support touch and writing.' },
      { list: [
        'Lower upfront cost, especially for large display sizes',
        'Can struggle in brightly lit rooms',
        'Bulbs or light sources need replacing over time',
        'More components to install and align'
      ] },
      { h2: 'Choosing the right size' },
      { p: 'Students at the back of the room should be able to read text comfortably. Larger rooms need larger panels or projected images. Visit a demo classroom or ask vendors to test in one of your rooms before deciding.' },
      { h2: 'Don’t forget the rest of the setup' },
      { list: [
        'Classroom audio so every student can hear videos and the teacher',
        'Reliable internet and power backup',
        'Safe wall mounting and cable management',
        'Teaching content and software licences',
        'A document camera for showing books and worksheets'
      ] },
      { h2: 'Teacher training is essential' },
      { p: 'The best equipment goes unused if teachers are not comfortable with it. Plan hands-on training sessions and simple guides, and identify a tech champion in each department.' },
      { h2: 'Start with a pilot' },
      { p: 'Set up one or two classrooms first, gather feedback from teachers and students, then roll out to more rooms with confidence.' },
      { h2: 'Warranty and support' },
      { p: 'Ask vendors about warranty length, on-site service, response times and spare parts availability. Good after-sales support matters as much as the equipment.' }
    ]
  },
  {
    slug: 'how-to-write-a-school-prospectus',
    title: 'How to Write a School Prospectus That Brings Admissions',
    excerpt: 'What to include in a school or college prospectus, how to structure it, and writing tips that help parents choose your institute.',
    date: '2026-10-24',
    readTime: '6 min read',
    author: 'Fedigma Team',
    category: 'Content & Design',
    relatedService: 'content-writing',
    body: [
      { p: 'A prospectus is more than a list of facilities. It is your chance to tell families who you are, what you believe in and why their child will thrive with you. Whether printed or shared as a PDF on WhatsApp, a good prospectus can tip the decision in your favour.' },
      { h2: 'What to include' },
      { list: [
        'A welcome message from the principal or founder',
        'Your vision, values and teaching approach',
        'Classes or courses offered and the curriculum or board',
        'Facilities, safety measures and transport',
        'Faculty strengths and student support',
        'Achievements, results and student life',
        'The admission process, key dates and documents required',
        'Fee information or how to request it',
        'Contact details, map and social media'
      ] },
      { h2: 'Write for parents, not inspectors' },
      { p: 'Use warm, simple language. Instead of listing "state-of-the-art infrastructure", describe what students actually do in your labs, library and playground. Specific details are more convincing than big claims.' },
      { h2: 'Show, don’t just tell' },
      { p: 'Real photos of your students, teachers and campus build far more trust than stock images. Short quotes from parents and students add credibility.' },
      { h2: 'Keep it easy to scan' },
      { p: 'Use clear headings, short paragraphs and plenty of white space. Parents often skim first, so put the most important information where it is easy to find.' },
      { h2: 'Make it work on phones' },
      { p: 'Many parents will read your prospectus as a PDF on their phone. Keep the file size small, use readable font sizes and create a version that looks good on a small screen.' },
      { h2: 'End with a clear next step' },
      { p: 'Close with an invitation to visit, book a campus tour or contact the admissions office, with a phone number, WhatsApp link and website address.' },
      { h2: 'Keep it current' },
      { p: 'Update your prospectus every year with new results, achievements, photos and dates. An outdated prospectus gives the impression of an inactive institution.' }
    ]
  },
  {
    slug: 'career-options-after-12th',
    title: 'Career Options After 12th: A Stream-Wise Guide for Students and Parents',
    excerpt: 'Popular courses and career paths after Class 12 for Science, Commerce and Humanities students, plus how to choose the right one.',
    date: '2026-10-24',
    readTime: '8 min read',
    author: 'Fedigma Team',
    category: 'Career Guidance',
    relatedService: 'career-counselling',
    body: [
      { p: 'Choosing what to do after Class 12 is one of the biggest decisions a student makes. There are more options today than ever before, which is exciting but can also feel overwhelming. This guide gives an overview of popular paths for each stream.' },
      { h2: 'Science with Maths (PCM)' },
      { list: [
        'Engineering (B.Tech/B.E.), usually through JEE or state entrance exams',
        'Architecture (B.Arch)',
        'B.Sc in Physics, Chemistry, Mathematics, Computer Science or Data Science',
        'BCA and computer applications',
        'Defence careers through NDA',
        'Merchant navy and aviation'
      ] },
      { h2: 'Science with Biology (PCB)' },
      { list: [
        'Medicine and dentistry (MBBS, BDS) through NEET',
        'AYUSH courses such as BAMS and BHMS',
        'Nursing, pharmacy and physiotherapy',
        'B.Sc in Biotechnology, Microbiology, Zoology or Botany',
        'Allied health sciences and nutrition'
      ] },
      { h2: 'Commerce' },
      { list: [
        'B.Com and B.Com (Honours)',
        'Chartered Accountancy (CA), Company Secretary (CS) and Cost Accountancy (CMA)',
        'BBA and management programmes',
        'Economics, finance and banking',
        'Digital marketing and business analytics'
      ] },
      { h2: 'Humanities and Arts' },
      { list: [
        'BA in subjects such as Psychology, Political Science, History, English and Economics',
        'Law (integrated five-year programmes, often through CLAT)',
        'Journalism and mass communication',
        'Design, including fashion and communication design',
        'Hotel management and hospitality',
        'Social work and public policy'
      ] },
      { h2: 'Options open to most streams' },
      { p: 'Many central and participating universities admit students through CUET. Students from any stream can also explore design, law, hotel management, mass communication, and later, civil services and government exams after graduation. Eligibility varies, so always check each course’s official requirements.' },
      { h2: 'How to choose the right path' },
      { list: [
        'Think about the subjects you enjoy and do well in',
        'Consider the kind of work you want to do every day',
        'Research the course, entrance exams, duration and costs',
        'Talk to people already working in the field',
        'Keep a backup option alongside your first choice'
      ] },
      { h2: 'When to talk to a career counsellor' },
      { p: 'If you are confused between options, under pressure from others, or unsure how your strengths match different careers, a counselling session with your parents can bring clarity and a clear action plan.' }
    ]
  },
  {
    slug: 'video-ideas-for-schools-and-coaching-institutes',
    title: '10 Video Ideas for Schools and Coaching Institutes',
    excerpt: 'Simple video ideas that build trust, showcase results and bring in admissions, plus tips for filming on a phone and editing well.',
    date: '2026-10-24',
    readTime: '5 min read',
    author: 'Fedigma Team',
    category: 'Content & Design',
    relatedService: 'creative-services',
    body: [
      { p: 'Video is the most engaging way to show families what your institute is really like. You don’t need expensive equipment to start: a modern smartphone, good light and thoughtful editing go a long way.' },
      { h2: '1. Campus tour' },
      { p: 'A two-minute walk through classrooms, labs, library and play areas helps parents picture their child at your institute.' },
      { h2: '2. Principal or founder message' },
      { p: 'A short, sincere message about your vision and values builds personal trust.' },
      { h2: '3. Topper and result celebrations' },
      { p: 'Interview toppers and show their reactions. Results videos are among the most shared content for coaching institutes.' },
      { h2: '4. Teacher introductions' },
      { p: 'Short clips of teachers sharing their subject and teaching style help students feel connected before they join.' },
      { h2: '5. Concept explainers' },
      { p: 'One-minute videos explaining a tricky concept or solving a question demonstrate teaching quality and attract students searching for help.' },
      { h2: '6. Student and parent testimonials' },
      { p: 'Real people speaking honestly are more convincing than any advertisement.' },
      { h2: '7. Event highlights' },
      { p: 'Annual day, sports day and festival celebrations show the joyful side of school life.' },
      { h2: '8. A day in the life' },
      { p: 'Follow a student or class through a typical day, from assembly to the final bell.' },
      { h2: '9. Admission process walkthrough' },
      { p: 'Explain how to apply, important dates and what to expect, answering common parent questions.' },
      { h2: '10. Exam and study tips' },
      { p: 'Quick tips before board or competitive exams position your faculty as trusted experts.' },
      { h2: 'Tips for better videos' },
      { list: [
        'Film in natural light or a well-lit room',
        'Use a simple clip-on microphone for clear audio',
        'Keep social media videos short: under 60 seconds for reels',
        'Add subtitles, since many people watch without sound',
        'Use your logo and colours consistently',
        'Follow your consent policy when filming students'
      ] },
      { p: 'Good editing turns ordinary footage into polished, shareable videos. If your team is busy, outsourcing editing lets you post consistently without extra effort.' }
    ]
  },
  {
    slug: 'admission-marketing-ideas-for-schools',
    title: '12 Admission Marketing Ideas for Schools That Actually Work',
    excerpt: 'Practical, low-cost ways to get more admission enquiries for your school, from your Google listing and website to parent referrals and ads.',
    date: '2026-10-22',
    readTime: '8 min read',
    author: 'Fedigma Team',
    category: 'Marketing & Social Media',
    relatedService: 'digital-marketing',
    body: [
      { p: 'Parents today research schools online long before they visit. They search Google, read reviews, scroll through Instagram and compare websites. If your school is hard to find or looks inactive online, you lose families before you ever get a chance to meet them.' },
      { p: 'Here are twelve admission marketing ideas that work for schools of every size, most of which cost little or nothing.' },
      { h2: '1. Complete your Google Business Profile' },
      { p: 'When parents search "schools near me", Google shows a map with three schools. A complete profile with photos, timings, admission details and recent updates gives you the best chance of being one of them.' },
      { h2: '2. Ask happy parents for Google reviews' },
      { p: 'Reviews are the first thing many parents read. Ask parents at PTMs and annual events, and send a direct review link on WhatsApp. Reply politely to every review, positive or negative.' },
      { h2: '3. Make admissions easy to find on your website' },
      { p: 'Put "Admissions Open" on your homepage with a clear enquiry form, fee information or a way to request it, the admission process and important dates. Parents should never have to hunt for it.' },
      { h2: '4. Make sure your website works on phones' },
      { p: 'Most parents browse on their phones. Test your website on a mobile: if it is slow or hard to read, fix that before spending money on ads.' },
      { h2: '5. Showcase results and achievements' },
      { p: 'Board results, competition wins, sports achievements and alumni stories build trust. Share them on your website and social media every time.' },
      { h2: '6. Post consistently on Instagram and Facebook' },
      { p: 'Three or four posts a week showing classrooms, activities, events and teachers helps parents picture their child at your school.' },
      { h2: '7. Run a referral programme' },
      { p: 'Current parents are your best marketers. A simple thank-you, such as a small fee concession for successful referrals, can bring in many admissions.' },
      { h2: '8. Host an open day or campus tour' },
      { p: 'Invite families to see the school, meet teachers and ask questions. Promote it online and collect registrations through a simple form.' },
      { h2: '9. Run targeted ads before admission season' },
      { p: 'Google and Instagram ads can target parents in nearby areas. Start 6–8 weeks before admissions open and send clicks to a focused admissions page, not your homepage.' },
      { h2: '10. Respond to enquiries fast' },
      { p: 'A parent who enquires today may visit another school tomorrow. Reply within hours, ideally on WhatsApp, and follow up politely.' },
      { h2: '11. Share helpful content for parents' },
      { p: 'Articles and videos on topics like choosing a school, exam preparation or child development build trust and help your website appear in more searches.' },
      { h2: '12. Track where enquiries come from' },
      { p: 'Ask every family how they heard about you, and track website form sources. Over time you will know which ideas actually bring admissions, and where to spend next year.' },
      { h2: 'Start with the basics' },
      { p: 'If you only do three things this season, complete your Google profile, collect more reviews and make admissions obvious on your website. These quick wins often bring the biggest results.' }
    ]
  },
  {
    slug: 'how-coaching-institutes-get-more-students-online',
    title: 'How Coaching Institutes Can Get More Students Online',
    excerpt: 'A practical guide for JEE, NEET, banking and SSC coaching institutes to attract more students through Google, social media, content and fast follow-up.',
    date: '2026-10-15',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'Marketing & Social Media',
    relatedService: 'online-presence',
    body: [
      { p: 'Students choosing a coaching institute compare options online: results, faculty, fees, reviews and demo classes. Institutes that show up clearly and respond quickly win more admissions, even against bigger brands.' },
      { h2: 'Be visible where students search' },
      { p: 'Searches like "best NEET coaching near me" or "bank exam coaching in Noida" are where admissions begin. To appear for them you need:' },
      { list: [
        'A complete Google Business Profile with photos, courses and timings',
        'Plenty of recent reviews from students and parents',
        'A website with a separate page for each course or exam',
        'Your location mentioned clearly on your website'
      ] },
      { h2: 'Build a course-led website' },
      { p: 'Each course page should cover the exam, batch timings, duration, fees or fee range, faculty, study material, mock tests and results. Add a "Book a free demo" button on every page.' },
      { h2: 'Show results proudly' },
      { p: 'Toppers, selections and rank holders are your strongest proof. Feature them on your homepage and share each result on Instagram, YouTube and WhatsApp.' },
      { h2: 'Create helpful free content' },
      { p: 'Daily current affairs, exam notifications, preparation tips, previous year papers and free mock tests bring students to your website and social media every day. Over time, this content builds trust and search visibility.' },
      { h2: 'Use short videos' },
      { p: 'Short reels and YouTube videos of faculty explaining concepts, solving questions or sharing strategy reach students where they already spend time.' },
      { h2: 'Run ads before every new batch' },
      { p: 'Targeted Google and Instagram ads a few weeks before each batch starts can fill seats quickly. Send ad clicks to a page for that specific batch with a simple enquiry form.' },
      { h2: 'Follow up within minutes' },
      { p: 'Students enquire at several institutes at once. Route every website and ad enquiry straight to a counsellor on WhatsApp so they can respond while interest is high.' },
      { h2: 'Measure and improve' },
      { p: 'Track enquiries, demo bookings and admissions by source. You will quickly see which channels bring serious students and which only bring clicks.' }
    ]
  },
  {
    slug: 'google-business-profile-for-schools',
    title: 'Google Business Profile for Schools and Institutes: A Step-by-Step Guide',
    excerpt: 'How to set up and optimise a Google Business Profile so parents and students find your school, coaching centre or library on Google Maps.',
    date: '2026-10-01',
    readTime: '6 min read',
    author: 'Fedigma Team',
    category: 'Marketing & Social Media',
    relatedService: 'online-presence',
    body: [
      { p: 'For most schools, coaching centres, play schools and libraries, the Google Business Profile is the single most important online listing. It is what appears on Google Maps and in the local results when someone searches for institutes near them.' },
      { h2: 'Step 1: Claim and verify your profile' },
      { p: 'Search for your institute on Google Maps. If a listing exists, claim it; if not, create one at business.google.com. Google will ask you to verify that you manage the institute, often by phone, email or a short video.' },
      { h2: 'Step 2: Choose the right category' },
      { p: 'Pick the most accurate primary category, such as "School", "Coaching center", "Preschool", "College" or "Library", and add relevant secondary categories.' },
      { h2: 'Step 3: Complete every detail' },
      { list: [
        'Exact name, as on your signboard',
        'Full address with a correctly placed map pin',
        'Phone number and WhatsApp-enabled number',
        'Website link',
        'Opening hours, including special hours for holidays',
        'A clear description of what you offer and who you serve'
      ] },
      { h2: 'Step 4: Add good photos' },
      { p: 'Upload photos of your building, classrooms, labs, library, activities and events. Profiles with real, recent photos look more trustworthy and get more clicks.' },
      { h2: 'Step 5: Collect and reply to reviews' },
      { p: 'Ask parents and students for reviews and make it easy with a direct link. Reply to every review: thank people for positive ones and respond calmly and helpfully to negative ones.' },
      { h2: 'Step 6: Post updates regularly' },
      { p: 'Use Google posts to share admission dates, results, events and new batches. Regular activity signals that your institute is active.' },
      { h2: 'Step 7: Answer questions' },
      { p: 'Check the questions section and answer common queries about fees, timings, transport and admissions. You can also add frequently asked questions yourself.' },
      { h2: 'Keep it consistent' },
      { p: 'Make sure your name, address and phone number match exactly across your website, social media and directories like Justdial. Consistency helps Google trust your listing.' }
    ]
  },
  {
    slug: 'choosing-a-school-management-system',
    title: 'How to Choose a School Management System: A Checklist for Principals',
    excerpt: 'What to check before you commit to a school ERP, from data migration and fee collection to parent apps and support.',
    date: '2026-10-20',
    readTime: '7 min read',
    author: 'Fedigma Team',
    category: 'ERP & Management',
    relatedService: 'school-management',
    body: [
      { p: 'Choosing a school management system is one of the biggest technology decisions a school makes. The right system saves your office hours every week and keeps parents informed. The wrong one ends up abandoned, with staff quietly going back to registers and spreadsheets.' },
      { p: 'Before you sit through another sales demo, use this checklist to compare options on what actually matters day to day.' },
      { h2: '1. Does it match how your school already works?' },
      { p: 'Every school has its own fee structure, grading rules, report card format and approval process. Ask whether the system can be configured to match these, or whether your staff will have to change how they work to suit the software. Small mismatches in fee concessions or report card layouts become big frustrations every term.' },
      { h2: '2. How will your existing data be moved across?' },
      { p: 'Student records, staff details and fee history usually live in spreadsheets or an older system. A good vendor will import this data for you as part of setup. Ask exactly what is included, how long it takes, and who checks that the imported records are correct.' },
      { h2: '3. Is fee collection simple for parents and the accounts team?' },
      { p: 'Fees are often the single biggest reason schools adopt an ERP. Check for:' },
      { list: [
        'Online payments through UPI, cards and net banking',
        'Automatic receipts and due-date reminders by SMS or WhatsApp',
        'Support for instalments, late fees, sibling discounts and concessions',
        'Clear reports on collections and pending dues by class'
      ] },
      { h2: '4. Will teachers actually use it?' },
      { p: 'Attendance and marks entry happen every day, so they must be fast. Ask to try marking attendance for a class of 40 on a phone. If it takes more than a minute, teachers will resist it.' },
      { h2: '5. What do parents get?' },
      { p: 'A parent app or portal with attendance alerts, homework, circulars, results and fee status reduces calls to the school office dramatically. Check that it works well on low-cost Android phones, since that is what most parents use.' },
      { h2: '6. Who owns the data, and how is it protected?' },
      { p: 'Your school should own its data and be able to export it at any time. Ask where data is hosted, how often it is backed up, and whether staff access is role-based so a class teacher cannot see the accounts module. With India’s Digital Personal Data Protection Act now in force, this matters more than ever.' },
      { h2: '7. What does support look like after launch?' },
      { p: 'Ask how staff training is delivered, how quickly support requests are answered during admissions and exam season, and whether updates are included. A cheaper system with poor support often costs more in lost time.' },
      { h2: 'Questions to ask in every demo' },
      { list: [
        'Can you show our exact report card format working in the system?',
        'What is included in setup and data migration?',
        'What are the total yearly costs, including SMS, hosting and updates?',
        'Can we export all our data if we leave?',
        'Can we speak to two schools already using it?'
      ] },
      { h2: 'The bottom line' },
      { p: 'The best school management system is the one your staff and parents actually use. Prioritise simplicity, a good fit with your existing processes, and a vendor who will set it up properly and support you through your first full academic year.' }
    ]
  },
  {
    slug: 'website-cost-in-india',
    title: 'How Much Does a Business Website Cost in India in 2026?',
    excerpt: 'A plain-English breakdown of website costs in India, what drives the price up or down, and the hidden yearly costs to plan for.',
    date: '2026-10-08',
    readTime: '6 min read',
    author: 'Fedigma Team',
    category: 'Websites & Apps',
    relatedService: 'web-development',
    body: [
      { p: '“How much does a website cost?” is the first question almost every business owner asks, and the honest answer is: it depends on what the website needs to do. This guide breaks down typical price ranges in India and what you get at each level.' },
      { h2: 'Typical price ranges' },
      { list: [
        'Simple business website (up to 5 pages): roughly ₹15,000 – ₹40,000',
        'Professional website with CMS and SEO (10–15 pages): roughly ₹40,000 – ₹1,00,000',
        'E-commerce store: roughly ₹60,000 – ₹2,50,000 depending on features',
        'Custom web application or portal: usually ₹1,50,000 and above'
      ] },
      { p: 'Prices vary widely between freelancers, small studios and large agencies. What matters more than the number is what is included.' },
      { h2: 'What drives the price' },
      { p: 'The biggest cost factors are:' },
      { list: [
        'Custom design versus a ready-made template',
        'Number of pages and how much content needs to be written',
        'Features such as booking, payments, logins or integrations',
        'Whether you need a CMS to edit content yourself',
        'SEO work, speed optimisation and analytics setup',
        'Length of support after launch'
      ] },
      { h2: 'Hidden yearly costs to plan for' },
      { p: 'The build cost is only part of the picture. Budget each year for:' },
      { list: [
        'Domain name renewal (₹800 – ₹1,500 for a .com or .in)',
        'Hosting (anywhere from ₹3,000 to ₹20,000+ depending on traffic)',
        'Business email accounts',
        'Maintenance, security updates and small content changes'
      ] },
      { h2: 'Cheap websites can be expensive' },
      { p: 'A very low-cost website often means a reused template, slow loading, poor mobile layout and no SEO foundations. If it doesn’t bring in enquiries, it has cost you money rather than earned it. Look for a partner who asks about your business goals before quoting a price.' },
      { h2: 'How to get an accurate quote' },
      { p: 'Before contacting developers, write down your goals, the pages you need, any features (forms, payments, bookings), two or three websites you like, and your timeline. With this, you will get accurate, comparable quotes and avoid surprise costs later.' }
    ]
  },
  {
    slug: 'native-vs-cross-platform-apps',
    title: 'Native vs Cross-Platform Apps: Which Is Right for Your Business?',
    excerpt: 'Flutter, React Native or fully native? A practical comparison of cost, speed, performance and maintenance for business apps.',
    date: '2026-09-24',
    readTime: '5 min read',
    author: 'Fedigma Team',
    category: 'Websites & Apps',
    relatedService: 'mobile-app',
    body: [
      { p: 'If you are planning a mobile app, one of the first technical decisions is whether to build it natively for each platform or with a cross-platform framework such as Flutter or React Native. The choice affects your budget, launch date and long-term maintenance.' },
      { h2: 'What is the difference?' },
      { p: 'Native apps are built separately for Android (in Kotlin) and iOS (in Swift). Cross-platform apps use one shared codebase that runs on both. Modern frameworks like Flutter produce apps that look and feel native to most users.' },
      { h2: 'When cross-platform makes sense' },
      { list: [
        'You want to launch on both Android and iOS with one budget',
        'Your app is mostly forms, lists, bookings, ordering or content',
        'You want faster updates with one team maintaining one codebase',
        'You are building a first version to test with real users'
      ] },
      { p: 'For most business apps, including ordering, booking, school and service apps, cross-platform development offers the best balance of cost and quality.' },
      { h2: 'When native is worth it' },
      { list: [
        'Heavy use of device hardware such as advanced camera, Bluetooth or sensors',
        'Graphics-intensive apps and games',
        'Apps where every millisecond of performance matters',
        'Products that need the newest platform features on day one'
      ] },
      { h2: 'What about cost?' },
      { p: 'Building two native apps typically costs significantly more than one cross-platform app, because the work is largely done twice. Maintenance follows the same pattern: two codebases mean two sets of updates for every change.' },
      { h2: 'Our recommendation' },
      { p: 'Start with the problem your app solves and the users it serves. In India, most users are on Android, so many businesses launch there first. If you need both platforms, cross-platform is usually the smart default, and you can always build native modules for specific features later.' }
    ]
  }
];

export const getPostBySlug = (slug) => posts.find((post) => post.slug === slug);

export const formatPostDate = (date) =>
  new Date(date).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
